import ApiClient from '../../api/client';
import { setBasket, errorBasket, pending, clearErrorBasket } from './reducer';

const makeRequestAction = (request) => (pk, quantity) => async (dispatch) => {
  dispatch(pending())
  dispatch(clearErrorBasket({ pk }));
  try {
    const { data } = await request(pk, quantity);
    dispatch(setBasket(data))
  } catch (err) {
    dispatch(errorBasket({ pk, error: err.responseJSON }))
  }
}

export const fetchBasket = makeRequestAction(ApiClient.basket.fetchBasket);

export const setQuantity = makeRequestAction(ApiClient.basket.setQuantity);

export const removeProduct = makeRequestAction(ApiClient.basket.removeProduct);

export const addProduct = makeRequestAction(ApiClient.basket.addProduct);

export const setDiscount = (code, paramName='voucher_code') => async (dispatch) => {
  dispatch(pending())
  dispatch(clearErrorBasket({}));
  try {
    const { data } = await ApiClient.basket.setDiscount(code, paramName);
    dispatch(setBasket(data))
  } catch (err) {
    dispatch(errorBasket({ error: err.responseJSON }))
  }
}

export const removeDiscount = () => async (dispatch) => {
  dispatch(pending())
  dispatch(clearErrorBasket({}));
  try {
    const { data } = await ApiClient.basket.removeDiscount();
    dispatch(setBasket(data))
  } catch (err) {
    dispatch(errorBasket({ error: err.responseJSON }))
  }
}